import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "af_cookie_prefs";

// Permite reabrir el centro de preferencias desde el footer.
export function openCookiePreferences() {
  window.dispatchEvent(new CustomEvent("af-open-cookies"));
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showConfig, setShowConfig] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) setVisible(true);
    else {
      try {
        const p = JSON.parse(saved);
        setAnalytics(!!p.analytics);
        setMarketing(!!p.marketing);
      } catch (_) {}
    }
    const open = () => { setShowConfig(true); setVisible(true); };
    window.addEventListener("af-open-cookies", open);
    return () => window.removeEventListener("af-open-cookies", open);
  }, []);

  const save = (prefs) => {
    localStorage.setItem(KEY, JSON.stringify({ necessary: true, ...prefs, ts: Date.now() }));
    setVisible(false);
    setShowConfig(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-3 md:p-5" data-testid="cookie-banner">
      <div className="af-card max-w-4xl mx-auto p-5 md:p-6" style={{ background: "rgba(20,20,20,0.98)", backdropFilter: "blur(8px)" }}>
        <div className="flex items-start gap-3">
          <Cookie className="text-af-orange-core shrink-0 mt-1" size={26} />
          <div className="flex-1">
            <div className="text-white font-semibold">Utilizamos cookies</div>
            <p className="text-white/65 text-sm mt-1 leading-relaxed">
              Usamos cookies estrictamente necesarias para el funcionamiento del sitio y, con tu consentimiento, cookies de analítica y publicidad.
              Puedes aceptarlas, rechazarlas o configurarlas. Consulta nuestra <Link to="/legal/cookies" className="text-af-orange-core underline">Política de Cookies</Link>.
            </p>

            {showConfig && (
              <div className="mt-4 space-y-3" data-testid="cookie-config">
                <label className="flex items-center justify-between gap-4 text-sm text-white/80">
                  <span>Estrictamente necesarias <span className="text-white/40">(siempre activas)</span></span>
                  <input type="checkbox" checked disabled />
                </label>
                <label className="flex items-center justify-between gap-4 text-sm text-white/80">
                  <span>Analítica y medición</span>
                  <input data-testid="cookie-analytics" type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
                </label>
                <label className="flex items-center justify-between gap-4 text-sm text-white/80">
                  <span>Publicidad y remarketing</span>
                  <input data-testid="cookie-marketing" type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />
                </label>
              </div>
            )}

            <div className="flex flex-wrap gap-3 mt-4">
              <button data-testid="cookie-accept-all" onClick={() => save({ analytics: true, marketing: true })} className="af-btn-primary" style={{ padding: "0.6rem 1.2rem", fontSize: "0.9rem" }}>Aceptar todas</button>
              <button data-testid="cookie-reject" onClick={() => save({ analytics: false, marketing: false })} className="af-btn-ghost" style={{ padding: "0.55rem 1.2rem", fontSize: "0.9rem" }}>Rechazar no esenciales</button>
              {showConfig
                ? <button data-testid="cookie-save" onClick={() => save({ analytics, marketing })} className="af-btn-ghost" style={{ padding: "0.55rem 1.2rem", fontSize: "0.9rem" }}>Guardar preferencias</button>
                : <button data-testid="cookie-configure" onClick={() => setShowConfig(true)} className="af-btn-ghost" style={{ padding: "0.55rem 1.2rem", fontSize: "0.9rem" }}>Configurar</button>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
